import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'//React routes
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { SupervisorAccountOutlined, PersonOutline } from '@mui/icons-material/';
import { TextField, IconButton, Slide, Typography, Card as CardCustom, CardContent, Box as BoxCustom, styled, useTheme } from '@mui/material';

import { UseImage, CustomLoadingOverlay, GenericContainer } from '../../components'
import { fileActions,addTitleLegoCurrent } from '../../store/actions';
import { coreFunctions } from '../../utils'
import noResultImg from '../../assets/noResult.png'
import { useTranslation } from 'react-i18next';

const Box = styled(BoxCustom)(({ theme }) => ({
    width: '100%',
    display: 'flex',
}));

const IconButtonCustom = styled(IconButton)(({ theme }) => ({
    height: '30px',
    width: '30px',
    '&:focus': {
        outline: 'none !important',
    },
}));

const TextFieldSearch = styled(TextField)(({ theme }) => ({
    "& .MuiOutlinedInput-input": {
        height: 25,
        padding: "10px 15px",
        [theme.breakpoints.down("sm")]: {
            height: 18,
            padding: "8px 10px",
        },
    },
    "& .MuiOutlinedInput-root": {
        borderRadius: 12,
        fontSize: 14,
        "& fieldset legend span": {
            display: "none",
        },
        [theme.breakpoints.down("sm")]: {
            // fontSize: '10px',
            // lineHeight: '144%',
            borderRadius: 2,
        },
    },
    "& .MuiInputLabel-root": {
        color: "#000",
        position: "relative",
        transform: "none",
        fontSize: "16px",
        marginBottom: 5,
        marginTop: 5,
        display: "flex",
        alignItems: "center",
        pointerEvents: "auto",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "140%",
        // fontFamily: '"Montserrat",sans-serif',
        [theme.breakpoints.down("sm")]: {
            fontWeight: 400,
            fontSize: "9px",
            lineHeight: "144%",
        },
    },
    "& label.Mui-focused": {
        color: theme.palette.primary.main,
    },
    "& label.Mui-error": {
        color: "#C20E30 !important",
        // #C20E30
    },
    "& .MuiSelect-select": {
        height: 25,
        "& .notranslate": {
            display: "block",
            margin: "2.45px 0",
        },
    },
    "& .MuiInputBase-multiline": {
        padding: "0",
    },
    input: {
        "&::placeholder": {
            [theme.breakpoints.down("sm")]: {
                fontWeight: 400,
                fontSize: "10px",
            },
        },
    },
}));

const Card = styled(CardCustom)(({ theme }) => ({
    border: `1px solid ${theme.palette.primary.color}`,
    margin: theme.spacing(1),
    '&:hover': {
        backgroundColor: theme.palette.secondary.contrastText
    },
    [theme.breakpoints.only('xs')]: {
        width: '100% !important',
    },
    [theme.breakpoints.only('sm')]: {
        width: '100% !important',
    },
    [theme.breakpoints.only('md')]: {
        width: '40% !important',
    },
    [theme.breakpoints.only('lg')]: {
        width: '45% !important',
    },
    [theme.breakpoints.only('xl')]: {
        width: '46% !important',
    },
}));

export default function SearchResultComponentSimple(props) {
    const navigate = useNavigate()

    const [loadView, setLoadView] = useState(false)
    const [openSearch, setOpenSearch] = useState(false)
    const [cardsData, setCardData] = useState([])
    const [search, setSearch] = useState('')
    const [selectSearchFile, setSelectSearchFile] = useState(false)
    const location = useLocation()

    const files = useSelector(state => state.FilesSearch)
    const file = useSelector((state) => state.FileInfo);
    
    const dispatch = useDispatch()
    const { t } = useTranslation();

    const handleClose = () => {
        setOpenSearch(false)
        setSearch('0')
    }

    useEffect(() => {
        if (location?.state?.forceReload) {
            dispatch(fileActions.GetFilesSearch({ "SearchText": search }));
        }
      }, [location?.state]);

    useEffect(() => {
        dispatch(addTitleLegoCurrent(t("general_solicitud")))
    }, [])
    
    useEffect(() => {
        dispatch(fileActions.GetFilesSearch({ "SearchText": search }))
    }, [search])

    useEffect(() => {
        setLoadView(files.loading)
        if (files.items != undefined) {
            setCardData(files.items)
        }
        if (files.error != undefined) {
            alert(files.error)
        }
    }, [files])

    const getFolio = (id) => {
        dispatch(fileActions.GetFileInfo(id));
        setSelectSearchFile(true)
        setLoadView(true)
    }

    useEffect(() => {
        if (file.items != undefined && selectSearchFile && file.items?.Stage != undefined) {
            setSelectSearchFile(false)
            let stageName = file.items.Stage.Name
            let stageId = file.items.Stage.Id
            let stage = file.items.Stage
            let folioId = file.items.Id
            let actorId = file.items.Stage.CurrentActor === null ? null : file.items.Stage.CurrentActor?.Id
            let nextComponent = coreFunctions.GetLegoNext(stageName)
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId, actorId } })
        }
    }, [file])

    return (<GenericContainer sx={{ width: '100% !important' }}>
        {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
        <Box sx={{
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
        }}>
            {!openSearch ?
                <IconButtonCustom
                    edge={openSearch ? 'end' : ''}
                    color="inherit"
                    onClick={() => { setOpenSearch(true) }}
                    aria-label="search">
                    <SearchIcon />
                </IconButtonCustom>
                : <Slide direction="left" in={openSearch} mountOnEnter unmountOnExit>
                    <Box sx={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                        <IconButtonCustom
                            edge="start"
                            color="inherit"
                            onClick={() => {
                                handleClose()
                            }}
                            aria-label="back">
                            <ArrowBackIcon />
                        </IconButtonCustom>
                        <TextFieldSearch type='text' fullWidth
                            placeholder={t("enter_search_criteria")}
                            value={search}
                            onChange={(e) => { setSearch(e.target.value) }}
                        />
                    </Box>
                </Slide>
            }
        </Box>

        <Box sx={{
            flexDirection: 'column',
            alignItems: 'center'
        }}>
            {/* <Typography variant="h6" gutterBottom>Solicitudes</Typography> */}
            {cardsData.length == 0
                ? <Box sx={{
                    height: '70vh',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <UseImage width={'40%'} src={noResultImg} />
                    <Typography variant="h6" gutterBottom>{t("no_results_found")}</Typography>
                </Box>
                : <Box sx={{
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                }}>{console.log('cardsData::',cardsData)}
                    {cardsData.map((card) =>
                        <Card 
                        id={`cardSigned_${card.Id}`}                        
                        onClick={() => {
                            console.log("Click card: ", card.Id)
                            getFolio(card.Id)
                        }}>
                            <CardContent sx={{
                                display: 'flex !important',
                                flexDirection: 'column',
                                alignItems: 'flex-start'
                            }}>
                                <Box sx={{
                                    flexDirection: 'column',
                                    alignItems: 'flex-start'
                                }}>
                                    <Typography 
                                        variant='p' 
                                        sx={(theme) => ({
                                            color: theme.palette.secondary.main
                                        })}
                                    >
                                        {`${t("folio_text")}: ${card.Folio}`}
                                    </Typography>
                                    <Typography variant='p'>{`${t("general_name")}: ${card?.FullName || ""}`}</Typography>
                                    <Typography variant='p'>{`${t("general_position_job")}: ${card.Metadata.find((item) => item.Name === 'Puesto')?.Value ?? "NA"}`}</Typography>
                                    <Typography variant='p'>{`${t("date_entry")}: ${card.Metadata.find((item) => item.Name === 'FechaIngreso')?.Value ?? "NA"}`}</Typography>
                                    <Typography variant='p'>{`${t("date_signature_assignment")}: ${card.Metadata.find((item) => item.Name === 'FechaAsignacionRepresentante')?.Value ?? "NA"}`}</Typography>
                                    <Typography variant='p'>{`${t("legal_status")}: ${card.Status}`}</Typography>

                                    {/* <Typography variant='p' sx={(theme) => ({
                                        color: theme.palette.secondary.main
                                    })}>{card.CreationDate?.length > 0 ? card.CreationDate : 'dd'}</Typography>
                                    <Typography variant='p'>{card.FullName != '' ? card.FullName : <>&nbsp;</>}</Typography>
                                    <Typography variant='p'>{`${t("folio_text")}: ${card.Folio}`}</Typography>
                                    <Typography variant='p'>{`${t("legal_status")}:${card.Status}`}</Typography> */}
                                </Box>
                                {card?.Stage?.CurrentStageGroup && card?.Stage?.TotalStageGroups &&
                                <Box sx={{
                                    flexDirection: 'column',
                                    alignItems: 'flex-end',
                                    justifyContent: 'space-between',
                                    width: '15%',
                                }}>
                                    {card.Metadata?.find(item => item.GroupName == "Solicitud" && item.Name == "Tipo de crédito")
                                        ?.Value == "Solicitud Grupal" ? <SupervisorAccountOutlined /> : <PersonOutline />}
                                    <Typography variant='p'>
                                        {`${card?.Stage?.CurrentStageGroup}/${card?.Stage?.TotalStageGroups === undefined
                                            ? card?.Stage?.CurrentStageGroup : card?.Stage?.TotalStageGroups}`}
                                    </Typography>
                                </Box>}
                            </CardContent>
                        </Card>
                    )}
                </Box>
            }
        </Box>
    </GenericContainer>)
}